import { MakeCall } from './createMakeCall';

const deleteConversationAttachment =
  (makeCall: MakeCall) => (conversationId: number, messageId: number) =>
    makeCall<undefined>(
      'DELETE',
      `/api/v2/conversation/${conversationId}/message/${messageId}`,
    );
export { deleteConversationAttachment };
